/* Jersey cart bundle - keeps the lines sharing a _TRIKOT id in step, so removing
 * the jersey removes its add-ons. The rows themselves are skipped in Liquid.
 * Cart Transform would do this natively but needs Plus. */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.moneyFormat);
      }
    } catch (e) {
      /* fall through */
    }
    return 'CHF ' + (Number(cents) / 100).toFixed(2);
  }

  function bundleId(item) {
    return (item.properties && item.properties._TRIKOT) || null;
  }

  function isMain(item) {
    return !!(item.properties && item.properties._bundle_type === 'main');
  }

  function isChild(item) {
    return !!(item.properties && item.properties._bundle_type === 'child');
  }

  function group(cart) {
    var groups = {};
    (cart.items || []).forEach(function (it, i) {
      var id = bundleId(it);
      if (!id) return;
      it._idx = i;
      (groups[id] = groups[id] || []).push(it);
    });
    return groups;
  }

  /* ---------- consistency ----------
   * Runs after every cart change, whatever triggered it - drawer, cart page or
   * a quantity stepper - so there is no need to intercept each of those flows.
   * A main line that is gone takes its children with it; otherwise children are
   * pulled to the main line's quantity. */
  var fixing = false;

  function reconcile(cart) {
    if (fixing) return Promise.resolve(cart);
    var groups = group(cart);
    var updates = {};

    Object.keys(groups).forEach(function (id) {
      var items = groups[id];
      var main = items.filter(isMain)[0];
      var kids = items.filter(isChild);
      if (!kids.length) return;
      if (!main) {
        kids.forEach(function (k) {
          updates[k.key] = 0;
        });
        return;
      }
      kids.forEach(function (k) {
        if (k.quantity !== main.quantity) updates[k.key] = main.quantity;
      });
    });

    if (!Object.keys(updates).length) return Promise.resolve(cart);

    fixing = true;
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return cart;
      })
      .then(function (updated) {
        fixing = false;
        // Let the theme redraw its cart sections with the corrected quantities.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return updated;
      });
  }

  /* ---------- badge ----------
   * Add-on lines are never rendered, but they still count towards cart.item_count,
   * so the header badge is corrected here. */
  function paint(cart) {
    var visible = 0;
    (cart.items || []).forEach(function (it) {
      if (!isChild(it)) visible += it.quantity;
    });
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count] .cart-count-badge__number').forEach(function (el) {
      el.textContent = visible;
    });
  }

  function run() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return reconcile(cart).then(function (fixed) {
          paint(fixed && fixed.items ? fixed : cart);
        });
      })
      .catch(function () {
        /* cart unavailable - leave the markup untouched */
      });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run whenever cart markup is re-rendered (drawer opening, section refresh).
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('.cart-item, cart-drawer-items, .cart-items')) ||
            (n.querySelector && n.querySelector('.cart-item'))) {
          schedule();
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:refresh', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    } catch (e) {
      /* pubsub not ready */
    }
  }
})();
